export default __webpack_public_path__ + "locales/fr/Settings.json?hash=bb9243863edf9faa87e12bf82623c5be";